import React, { Component } from 'react';
import styled from 'styled-components';
import ga from 'react-ga';
import { message } from 'antd';
import { Toy } from '../../Components';
import loading from './loading.svg';
import goal from './soccer-arch.svg';

class PlayGround extends Component {
  state = {
    imgs: [],
    uploading: false,
  };
  componentDidMount() {
    this.uploader.addEventListener('dragover', this.onDrag);
    this.uploader.addEventListener('dragleave', this.onDragLeave);
    this.uploader.addEventListener('drop', this.onDrop);
    this.uploader.addEventListener('click', () => this.input.click());
    this.uploader.addEventListener('touch', () => this.input.click());
    this.input.addEventListener('change', this.handleOriginUpload);
    this.getGoalPositionTimer = setTimeout(() => {
      this.goalPosition = this.goal.getBoundingClientRect();
    }, 1000);

    window.addEventListener('dragover', this.preventDefault);
    window.addEventListener('drop', this.preventDefault);
    window.addEventListener('touchmove', this.onTouchMove);
  }
  componentWillUnmount() {
    clearTimeout(this.getGoalPositionTimer);
    window.removeEventListener('dragover', this.preventDefault);
    window.removeEventListener('drop', this.preventDefault);
    window.removeEventListener('touchmove', this.onTouchMove);
  }

  onTouchMove = (e) => {
    e.preventDefault();
  };
  onDragLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.uploader.style.border = '1px grey dashed';
  };
  onDrag = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.uploader.style.border = '1px rgb(24, 144, 255) dashed';
  };

  onDrop = (e) => {
    this.handleUpload(e.dataTransfer.files);
  };
  preventDefault = (e) => {
    e.preventDefault();
  };
  handleOriginUpload = (e) => {
    this.handleUpload(e.target.files);
  };
  handleUpload = (files) => {
    const { imgs, uploading } = this.state;
    if (files && files[0] && !uploading && files[0].type.match(/^image/)) {
      ga.event({
        category: 'homepage interaction',
        action: 'upload image',
      });
      const reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          uploading: false,
          imgs: [...imgs, <Toy src={e.target.result} cb={this.checkGoal} />],
        });
      };
      reader.readAsDataURL(files[0]);
      this.setState({
        uploading: true,
      });
    } else if (uploading) {
      message.error('正在上傳圖片，請稍等~');
    } else {
      message.error('只能上傳圖片哦！');
    }
  };
  checkGoal = ({ x, y }) => {
    if (x > window.innerWidth - 100 && y > this.goalPosition.y - 250) {
      ga.event({
        category: 'homepage interaction',
        action: 'goal',
      });
      message.success('得分!!!');
    }
  };
  render() {
    const { imgs, uploading } = this.state;
    const { className } = this.props;
    return (
      <div className={className}>
        {imgs}
        <div className="upload-wrapper">
          <input
            className="input"
            style={{ display: 'none' }}
            ref={(r) => {
              this.input = r;
            }}
            type="file"
          />
          <div className="loading-background">
            <div style={{ display: uploading ? 'block' : 'none' }} className="loading">
              <img src={loading} alt="" />
            </div>
            <div
              style={{ opacity: uploading ? '0' : '0.5' }}
              ref={(r) => {
                this.uploader = r;
              }}
              className="uploader"
            >
              <div>+</div>
              <div>Upload an image to play</div>
            </div>
          </div>
        </div>
        <img
          src={goal}
          alt="goal-white"
          className="goal"
          ref={(r) => {
            this.goal = r;
          }}
        />
      </div>
    );
  }
}

export default styled(PlayGround)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  .upload-wrapper {

    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-background {
      position: relative;
      width: 200px;
      height: 200px;
      border-radius: 5px;
      border: 1px grey dashed;
        &:hover {
          border: 1px rgb(24, 144, 255) dashed;
        }
        .loading {
          position: absolute;
          width: 200px;
          height: 200px;
          animation: load 2s infinite;
          @keyframes load {
            0%  { transform: rotate(0deg);}
            100%{ transform: rotate(360deg);}
          }
          img {
            width: 100px;
            height: 100px;
            margin: 50px 50px;
          }
        }
      }
      .uploader {
        text-align: center;
        border-radius: 5px;
        border: 2px transparent dashed;
        width: 200px;
        height: 200px;
        background: #FAFAFA;
        font-size: 30px;
        color: black;
        transition: opacity 200ms;
        div:first-child {
          font-size: 60px;
        }
      }
    }
  }
  .goal {
    position: fixed;
    bottom: -200px;
    right: -50px;
    width: 200px;
    height: 200px;
    animation: goal-move 1s 1s forwards;
    pointer-events: none;
  }
  @keyframes goal-move {
    0% { transform: translateY(0px); }
    100% { transform: translateY(-200px);}
  }
  @keyframes goal-move-m {
    0% { transform: translateY(0px); }
    100% { transform: translateY(-150px);}
  }
  @media (max-width:768px){
    .upload-wrapper {
      transform: scale(0.5);
    }
    .goal {
      width: 100px;
      animation: goal-move-m 1s 1s forwards;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/PlayGround/index.js